export default [
    {
        path: '/asset/asset-movement',
        name: 'asset-movement',
        props: true,
        component: () => import('@/views/asset/movement/index.vue'),
        meta: {
            pageTitle: 'Asset Movement',
            breadcrumb: [
                {
                text: 'Asset Movement',
                active: true,
                },
            ],
        },
    },
    {
        path: '/asset/asset-movement/add',
        name: 'create-asset-movement',
        component: () => import('@/views/asset/movement/create.vue'),
        meta: {
            pageTitle: 'Create Asset Movement',
            breadcrumb: [
                {
                text: 'Asset Movement',
                to: { name: 'asset-movement' },
                },
                {
                text: 'Create Asset Movement',
                active: true,
                },
            ],
        },
    },
    {
        path: '/asset/asset-movement/:id',
        name: 'detail-asset-movement',
        props: true,
        component: () => import('@/views/asset/movement/detail.vue'),
        meta: {
            pageTitle: 'Detail Asset Movement',
            breadcrumb: [
                {
                text: 'Asset Movement',
                to: { name: 'asset-movement' },
                },
                {
                text: 'Detail Asset Movement',
                active: true,
                },
            ],
        },
    },
]